<template>
  <div class="pt-3">
    <div v-if="!loading" class="d-flex justify-center">
      <div v-if="course" class="_temp_list">
        <on-course />
        <v-card flat :class="`rounded_max mb-3 banner_page`">
          <div :class="` temp_title cat_${course.course_categories_id}`">
            <img
              :src="banner[course.course_categories_id]"
              class="img_banner"
              height="200"
              alt="banner id"
            />
            <div class="content_banner pa-3">
              <v-row no-gutters>
                <v-col cols="10" lg="6" md="6">
                  <div
                    class="d-flex flex-column justify-space-between"
                    style="min-height: 170px"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="white"
                          v-bind="attrs"
                          v-on="on"
                          to="/course/cr/list"
                          icon
                          ><v-icon>mdi-reply</v-icon></v-btn
                        >
                      </template>
                      <span>Back</span>
                    </v-tooltip>
                    <div>
                      <div class="d-flex align-center">
                        <h3 class="white--text">{{ course.title }}</h3>
                        <v-btn icon dark @click="detil = !detil">
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                      </div>
                      <p class="white--text ma-0">
                        {{
                          course.course_categories_id == 1
                            ? "Lead Self"
                            : course.course_categories_id == 2
                            ? "Lead Others"
                            : "Professional Preparation"
                        }}
                      </p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="2" lg="6" md="6">
                  <div class="d-flex justify-end">
                    <v-btn
                      small
                      fab
                      depressed
                      color="#fff"
                      :to="`/course/update/${course.id}`"
                      v-if="
                        role == 'SUPERADMIN' ||
                        permissions.includes('LD') ||
                        permissions.includes('TEACHER')
                      "
                    >
                      <v-icon>mdi-cog</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <v-row no-gutters v-if="detil">
            <v-col cols="12" md="6" lg="6">
              <div class="pa-3">
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-calendar</v-icon>
                  </v-col>
                  <v-col cols="5">
                    <b class="small_txt">Start</b>
                    <p class="default_txt">
                      {{ $date(course.start_course).format("YYYY-MM-DD") }}
                      {{ $date(course.start_course).format("HH:mm") }}
                    </p>
                  </v-col>
                  <v-col cols="5">
                    <b class="small_txt">End</b>
                    <p class="default_txt">{{ course.end_date }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="1">
                    <v-icon>mdi-text</v-icon>
                  </v-col>
                  <v-col cols="11">
                    <b class="small_txt">About Course</b>
                    <p class="default_txt">{{ course.description }}</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <list-section
          :course="course"
          v-if="
            role == 'SUPERADMIN' ||
            permissions.includes('LD') ||
            permissions.includes('GUEST') ||
            permissions.includes('TEACHER')
          "
        />
        <ListSectionS
          :course="course"
          v-if="
            !permissions.includes('LD') &&
            (role == 'SCHOLAR' ||
              permissions.includes('UPCM') ||
              permissions.includes('ELSN') ||
              permissions.includes('MENTOR') ||
              permissions.includes('FASILITATOR'))
          "
        />
      </div>
    </div>
    <div v-if="loading">
      <loading-lg />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OnCourse from "../../../../components/course/breadcrumbs/onCourse.vue";
import ListSection from "../../section/admin/listSection";
import ListSectionS from "../../section/scholar/listSection.vue";
export default {
  components: { ListSection, ListSectionS, OnCourse },
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
      banner: (state) => state.banner,
    }),
  },
  name: "courseDetail",
  data() {
    return {
      loading: false,
      course: null,
      detil: false,
    };
  },

  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/course?filter[id]=${this.$route.params.idCourse}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.course = data.data[0];
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },

    toCreate(id) {
      this.$router.push(`/section/inclass/${id}/create`);
    },
  },
};
</script>

<style></style>
